import Alert from 'react-s-alert';

export default function getErrors(err) {
  if (!err.response) {
    return Promise.resolve([err.toString()]);
  }

  return err.response.json().then((response) => {
    if (!response.errors) {
      return [`${err.name}: ${err.message}`];
    }

    if (response.errors.length === 0) {
      return ['Неизвестная ошибка'];
    }

    return response.errors
      .filter(item => item.code !== 4)
      .map((item) => {
        if (item.title && item.detail) return `${item.title}. ${item.detail}.`;

        return item.title || item.detail;
    });
  }, () => [err.toString()]);
}

export function processErrorByAlert(err) {
  getErrors(err).then((errors) => {
    errors.forEach(error => Alert.error(error));
  });
}

export async function isCode4(error) {
  if (!error || !error.response) return false;

  try {
    const response = await error.response.clone().json();
    if (!response || !response.errors || response.errors.length > 1) return false;

    return response.errors[0].code === 4;
  } catch (err) {
    return false;
  }
}
